import { render, staticRenderFns } from "./EyecatcherItem.vue?vue&type=template&id=1f5c9228&scoped=true&"
import script from "./EyecatcherItem.vue?vue&type=script&lang=js&"
export * from "./EyecatcherItem.vue?vue&type=script&lang=js&"
import style0 from "./EyecatcherItem.vue?vue&type=style&index=0&id=1f5c9228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c9228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VImg,VListItem,VListItemContent,VListItemTitle})
